import './style.scss';
import Toggle from './toggle.js';

export default Toggle;